document.addEventListener("DOMContentLoaded", () => {
  const mapContainer = document.getElementById("locations-map");

  if (mapContainer) {
    showMap();
  }
});

async function showMap() {
  const mapContainer = document.getElementById("locations-map");
  const elementId = mapContainer.id;
  const rawAddresses = mapContainer.dataset.addresses;

  const addresses = JSON.parse(rawAddresses);
  const mapStyle = getDefaultMapStyle();
  let centerCoord;

  for (let i = 0; i < addresses.length; i++) {
    if (addresses[i].latitude && addresses[i].longitude) {
      centerCoord = {
        lat: parseFloat(addresses[0].latitude),
        lng: parseFloat(addresses[0].longitude),
      };
    }
  }

  const { Map } = await google.maps.importLibrary("maps");

  const map = new Map(document.getElementById(elementId), {
    zoom: 12,
    center: centerCoord,
    styles: mapStyle,
  });

  for (let i = 0; i < addresses.length; i++) {
    if (addresses[i].latitude && addresses[i].longitude) {
      const label = i + 1;

      const marker = new google.maps.Marker({
        position: {
          lat: parseFloat(addresses[i].latitude),
          lng: parseFloat(addresses[i].longitude),
        },
        title: addresses[i].name,
        label: {
          color: "white",
          fontWeight: "bold",
          text: label.toString(),
        },
        map,
      });
    }
  }
}

function getDefaultMapStyle() {
  return [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [{ color: "#c7c4c7" }],
    },
    {
      featureType: "administrative.country",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#6d438d" }],
    },
    {
      featureType: "administrative.province",
      elementType: "geometry.stroke",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative.neighborhood",
      elementType: "geometry.fill",
      stylers: [{ color: "#8e6ba8" }],
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        { lightness: "0" },
        { saturation: "0" },
        { color: "#f4f5f1" },
        { gamma: "1" },
      ],
    },
    {
      featureType: "landscape.man_made",
      elementType: "all",
      stylers: [{ lightness: "-3" }, { gamma: "1.00" }],
    },
    {
      featureType: "landscape.natural.terrain",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "geometry.fill",
      stylers: [{ color: "#b59ac9" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [{ color: "#cbe2a7" }, { visibility: "on" }],
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        { saturation: -100 },
        { lightness: "65" },
        { visibility: "simplified" },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [{ visibility: "simplified" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{ color: "#a892e8" }, { visibility: "simplified" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text",
      stylers: [{ color: "#4e4e4e" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{ color: "#787878" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [{ visibility: "simplified" }],
    },
    {
      featureType: "transit",
      elementType: "geometry.fill",
      stylers: [{ color: "#b59ac9" }],
    },
    {
      featureType: "transit",
      elementType: "labels.text.fill",
      stylers: [
        { color: "#8065CE" },
        { saturation: "-50" },
        { lightness: "0" },
      ],
    },
    {
      featureType: "transit.line",
      elementType: "geometry.fill",
      stylers: [{ color: "#b59ac9" }],
    },
    {
      featureType: "transit.line",
      elementType: "labels.text.fill",
      stylers: [{ lightness: "0" }],
    },
    {
      featureType: "transit.station.airport",
      elementType: "labels.icon",
      stylers: [
        { hue: "#0a00ff" },
        { saturation: "-77" },
        { gamma: "0.57" },
        { lightness: "0" },
      ],
    },
    {
      featureType: "transit.station.rail",
      elementType: "labels.text.fill",
      stylers: [{ color: "#8f7f93" }, { lightness: "0" }],
    },
    {
      featureType: "transit.station.rail",
      elementType: "labels.icon",
      stylers: [
        { lightness: "42" },
        { gamma: "0.75" },
        { saturation: "-68" },
        { hue: "#9200ff" },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [{ color: "#eaf6f8" }, { visibility: "on" }],
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [{ color: "#cee5f2" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ lightness: "-49" }, { saturation: "-53" }, { gamma: "0.79" }],
    },
  ];
}
